import { useMutation, useQueryClient } from '@tanstack/react-query'
import { liveCheckinMonthsTasksService } from '../../services/lives-checkins-months-tasks'
import { GET_OR_CREATE_MONTH_KEY } from './use-get-or-create-month'
import { MONTH_TASKS_KEY } from './use-get-month-tasks'

export function useDoCheckin() {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (userId: number) =>
      liveCheckinMonthsTasksService.doCheckin({ userId }),
    onSuccess: () => {
      // Atualiza o progresso das tarefas e o mês (pontos/nível podem ter mudado).
      queryClient.invalidateQueries({ queryKey: [MONTH_TASKS_KEY] })
      queryClient.invalidateQueries({ queryKey: [GET_OR_CREATE_MONTH_KEY] })
    },
  })

  return {
    doCheckin: mutation.mutate,
    doCheckinAsync: mutation.mutateAsync,
    isCheckingIn: mutation.isPending,
    result: mutation.data ?? null,
  }
}
